<!--
 * @Author: shiao
 * @Date: 2020-12-29 11:27:23
 * @LastEditTime: 2021-01-28 15:51:50
 * @Description: 入住预定
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\detail\checkin.vue
-->
<template>
  <div class="checkin-body">
    <div class="checkin-nav">
      <navbar title="选择入住信息" :lefticon="closeblackbtn" :lefticonheight="1.5" :lefticonwidth="1.5" :fontweight="500"
        fontsize="1.6rem" @goback="goback(false)" />
    </div>
    <div class="people-div" :style="peopleStyle" @click="closepeople">
      <div class="people-title">房间&人数</div>
      <div class="people-info">
        <span class="people-activate">{{ hotel.ckeckinInfo.roomNum }}间</span>
        <span class="people-activate">{{ hotel.ckeckinInfo.adultNum }}成人</span>
        <span
          :class="hotel.ckeckinInfo.childNum ? 'child-text-acivate' : 'child-text'">{{ hotel.ckeckinInfo.childNum }}儿童</span>
        <span class="people-close-img"><img :src="peopleshow ? closeupblackicon : openbottomblackicon" alt="" /></span>
      </div>
    </div>
    <div class="form-info-div" v-show="peopleshow">
      <div class="people-form-div">
        <div class="form-item-div">
          <div>1间</div>
          <van-stepper v-model="hotel.ckeckinInfo.roomNum" theme="round" button-size="16" disable-input max="10"
            async-change @change="onRoomChange" />
        </div>
        <div class="form-item-div">
          <div>成人</div>
          <van-stepper v-model="hotel.ckeckinInfo.adultNum" theme="round" button-size="16" disable-input max="80"
            async-change @change="onAdultChange" />
        </div>
        <div class="form-item-div">
          <div>儿童</div>
          <van-stepper v-model="hotel.ckeckinInfo.childNum" theme="round" button-size="16" disable-input :min="0"
            max="30" />
        </div>
      </div>
      <div class="child-info" v-show="hotel.ckeckinInfo.childNum != 0">
        <div class="info-tip">为了匹配合适的住宿，请填写儿童年龄</div>
        <div class="child-info-item" v-for="(item, index) in hotel.ckeckinInfo.childNum" :key="index"
          @click="cahngeChildAge(index)">
          <div class="info-title">第{{ index + 1 }}位儿童</div>
          <div class="info-yaer">
            {{ hotel.ckeckinInfo.childAgeList[index] == null ? "&lt;1岁"  : hotel.ckeckinInfo.childAgeList[index] }}
            <div class="child-img">
              <img :src="rightarrowblackicon" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="time-div" :style="timeSelectStyle" @click="changeTime">
      <div class="time-div-title">入离日期</div>
      <div class="time-data">
        {{ ckeckinInfo.start_time }} ~ {{ ckeckinInfo.end_time }}
      </div>
      <span class="time-close-img">
        <img :src="timeshow ? closeupblackicon : openbottomblackicon" alt="" />
      </span>
    </div>
    <div class="time-select" v-show="timeshow">
      <van-calendar title=" " :poppable="false" :show-confirm="false" color="#108B30" type="range" @confirm="onConfirm"
        :formatter="formatter" :default-date="defaultdate" :max-date="maxDate" @select="selectTime" />
    </div>
    <div class="checkin-bottom">
      <div :class=" checkinBtnstatus ? 'checkin-btn' : 'checkin-btn-gray'" @click="goback(true)">确定</div>
    </div>
    <van-popup v-model="childshow" round position="bottom" :style="{ height: '50%' }">
      <div class="checkin-pup-div">
        <div class="pup-title">选择第 {{childAgeListIndex + 1}} 位儿童年龄</div>
        <div class="pup-tip">选择儿童年龄，我们为您精准筛选可入住房型</div>
        <div :class="(hotel.ckeckinInfo.childAgeList[childAgeListIndex] == null ? '<1岁' :hotel.ckeckinInfo.childAgeList[childAgeListIndex] )== item ? 'pup-child-btn-activate': 'pup-child-btn'
          " v-for="(item, i) in childageList" :key="i" @click="chooseChildage(item)">
          {{ item }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import navbar from "../components/nav-bar.vue";
  import {
    mapState
  } from "vuex";
  import {
    Toast
  } from "vant";
  export default {
    components: {
      navbar,
    },
    data() {
      return {
        closeblackbtn: require("@/assets/hotel/img/micon/close-black-btn.png"),
        openbottomblackicon: require("@/assets/hotel/img/micon/open-bottom-black-icon.png"),
        closeupblackicon: require("@/assets/hotel/img/micon/close-up-black-icon.png"),
        rightarrowblackicon: require("@/assets/hotel/img/micon/right-arrow-black-icon.png"),
        childshow: false, //是否显示儿童选择年龄
        timeSelectStyle: {
          padding: "2.0rem 1.5rem",
          "margin-top": "2.0rem",
        },
        peopleStyle: {
          "box-shadow": "0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1)"
        },
        peopleshow: true, //人员预订订单是否展开
        timeshow: false, //日期组件是否显示
        ckeckinInfo: {}, //入住信息
        childageList: [
          "<1岁",
          "1岁",
          "2岁",
          "3岁",
          "4岁",
          "5岁",
          "6岁",
          "7岁",
          "8岁",
          "9岁",
          "10岁",
          "11岁",
          "12岁",
          "13岁",
          "14岁",
          "15岁",
          "16岁",
          "17岁",
        ],
        childAgeListIndex: 0, //儿童年龄的位置
        defaultdate: null,
        maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth() == 2 ? new Date().getMonth() - 2 :
          new Date().getMonth() - 1, 30),
        // new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 366),new Date(new Date().getFullYear()+1, new Date().getMonth()+1,new Date().getDate()),
        checkinBtnstatus: false, //入住按钮能否点击
      };
    },
    computed: {
      ...mapState({
        hotel: (state) => state.hotel,
      }),
    },
    created() {
      this.defaultdate = [
        this.hotel.ckeckinInfo.start_timeDate,
        this.hotel.ckeckinInfo.end_timeDate,
      ];
      this.onConfirm([
        this.hotel.ckeckinInfo.start_timeDate,
        this.hotel.ckeckinInfo.end_timeDate,
      ]);
      if (this.$route.query.timeSelect === '1') {
        this.timeshow = true
        this.closepeople()
      }
    },
    methods: {
      //格式化处理时间
      formatDate(date) {
        const week = date.getDay();
        let str = "";
        if (week == 0) {
          str = "周日";
        } else if (week == 1) {
          str = "周一";
        } else if (week == 2) {
          str = "周二";
        } else if (week == 3) {
          str = "周三";
        } else if (week == 4) {
          str = "周四";
        } else if (week == 5) {
          str = "周五";
        } else if (week == 6) {
          str = "周六";
        }
        let time = `${
        String(date.getMonth() + 1).length == 1
          ? "0" + String(date.getMonth() + 1)
          : date.getMonth() + 1
      }.${
        String(date.getDate()).length == 1
          ? "0" + String(date.getDate())
          : date.getDate()
      } ${str}`;
        let timeweek = `${
        String(date.getMonth() + 1).length == 1
          ? "0" + String(date.getMonth() + 1)
          : date.getMonth() + 1
      }月${
        String(date.getDate()).length == 1
          ? "0" + String(date.getDate())
          : date.getDate()
      }日 ${str}`;
        return [time, timeweek];
      },
      monthformatDate(date) {
        return `${date.getFullYear()}-${
        String(date.getMonth() + 1).length == 1
          ? "0" + String(date.getMonth() + 1)
          : date.getMonth() + 1
      }-${
        String(date.getDate()).length == 1
          ? "0" + String(date.getDate())
          : date.getDate()
      }`;
      },
      //日历点击事件
      onConfirm(date) {
        const [start, end] = date;
        if (start.getTime() + 24 * 60 * 60 * 1000 * 31 >= end.getTime()) {
          this.checkinBtnstatus = true
        } else {
          Toast('只能选择入住时间之后的31天内的某个日期')
          return
        }
        this.show = false;
        this.$set(this.ckeckinInfo, "start_time", this.formatDate(start)[0]);
        this.$set(this.ckeckinInfo, "end_time", this.formatDate(end)[0]);
        this.$set(this.hotel.ckeckinInfo, "start_timeWeek", this.formatDate(start)[1]);
        this.$set(this.hotel.ckeckinInfo, "end_timeWeek", this.formatDate(end)[1]);
        this.$set(this.hotel.ckeckinInfo, "start_time", this.monthformatDate(start));
        this.$set(this.hotel.ckeckinInfo, "end_time", this.monthformatDate(end));
        this.$set(this.hotel.ckeckinInfo, "start_timeDate", start);
        this.$set(this.hotel.ckeckinInfo, "end_timeDate", end);
        this.hotel.ckeckinInfo.roomday = Math.ceil(
          (this.hotel.ckeckinInfo.end_timeDate.getTime() -
            this.hotel.ckeckinInfo.start_timeDate.getTime()) /
          (24 * 60 * 60 * 1000)
        );
      },
      selectTime(date) {
        if (!date[1]) {
          this.checkinBtnstatus = false
          return
        }
      },
      //配置日历显示中文名称
      formatter(day) {
        const year = day.date.getFullYear();
        const month = day.date.getMonth() + 1;
        const date = day.date.getDate();
        const todayyear = new Date().getFullYear();
        const todaymonth = new Date().getMonth() + 1;
        const todaydate = new Date().getDate();
        if (year === todayyear && month === todaymonth && date === todaydate) {
          day.text = "今天";
        }
        if (day.type === "start") {
          day.bottomInfo = "入住";
        } else if (day.type === "end") {
          day.bottomInfo = "离店";
        }
        return day;
      },
      // 在修改房间数量的时候修改成人数量
      onRoomChange() {
        if (this.hotel.ckeckinInfo.roomNum > this.hotel.ckeckinInfo.adultNum) {
          this.hotel.ckeckinInfo.adultNum = this.hotel.ckeckinInfo.roomNum
        }
      },
      // 在修改成人数量的时候修改房间数量
      onAdultChange() {
        if (this.hotel.ckeckinInfo.adultNum < this.hotel.ckeckinInfo.roomNum) {
          this.hotel.ckeckinInfo.roomNum = this.hotel.ckeckinInfo.adultNum
        }
      },
      //选择儿童弹窗
      cahngeChildAge(index) {
        this.childAgeListIndex = index;
        this.childshow = true;
      },
      //选择儿童实际年龄
      chooseChildage(age) {
        this.hotel.ckeckinInfo.childAgeList[this.childAgeListIndex] = age;
        this.childshow = false;
      },
      //关闭与开启表单信息
      closepeople() {
        if (this.peopleshow) {
          this.peopleshow = false;
          this.timeSelectStyle = {
            padding: "0rem 1.5rem 2.0rem",
            "box-shadow": "0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1)",
          };
          this.peopleStyle = {}
        } else {
          this.peopleshow = true;
          this.timeshow = false
          this.timeSelectStyle = {
            padding: "2.0rem 1.5rem ",
            "margin-top": "2.0rem",
          };
          this.peopleStyle = {
            "box-shadow": "0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1)"
          }
        }
      },
      changeTime() {
        this.timeshow = !this.timeshow;
        if (this.timeshow) {
          this.peopleshow = false;
          this.timeSelectStyle = {
            padding: "0rem 1.5rem 2.0rem",
          };
          this.peopleStyle = {}
          // this.timeSelectStyle = {
          //   padding: "20rem 15rem",
          //   "margin-top": "20rem",
          // };
        } else {
          this.timeSelectStyle = {
            padding: "0rem 1.5rem 2.0rem",
            "box-shadow": "0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1)",
          };
          if (this.peopleshow) {
            this.peopleStyle = {
              "box-shadow": "0rem 0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1)"
            }
          }
          // this.timeSelectStyle = {
          //   padding: "20rem 15rem 79rem",
          //   "margin-top": "20rem",
          // };
        }
      },
      //返回上一页
      goback(val) {
        if (!val) {
          this.$router.go(-1);
          return
        }
        // if(this.hotel.ckeckinInfo.childNum  > this.hotel.ckeckinInfo.adultNum){
        //   Toast('儿童人数不能大于成人人数')
        //   return
        // }else 
        if (this.hotel.ckeckinInfo.end_timeWeek == '') {
          Toast('请选择离店日期')
          return
        }
        this.$router.go(-1);
      },
    },
  };
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
</style>
<style lang='less'>
  .time-select {
    height: calc(100% - 25.2rem);

    .van-calendar__header-title {
      display: none;
    }
  }

  .people-form-div {
    .van-stepper--round .van-stepper__minus {
      color: #fff !important;
      background-color: #aaa;
      border: 0.1rem solid #aaa;
    }

    .van-stepper--round .van-stepper__plus {
      color: #fff;
      background-color: #108b30;
    }

    .van-stepper__input {
      height: 2.5rem !important;
      font-size: 1.8rem;
      font-weight: 500;
      color: #181818;
      line-height: 2.5rem;
    }
  }
</style>
<style lang="less" scoped>
  .checkin-body {
    background: #fbfbfb;
    height: 100%;
  }

  .checkin-nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #ffffff;
    z-index: 3;
  }

  .people-div {
    display: flex;
    padding: 10.3rem 1.5rem 1.5rem;
    background-color: #ffffff;
    position: relative;
    z-index: 2;
    justify-content: space-between;

    .people-title {
      width: auto;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
    }

    .people-info {
      flex: 1;
      text-align: right;
    }

    .people-activate {
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #108b30;
      line-height: 2.2rem;
      margin-right: 1.0rem;
    }

    .child-text,
    .child-text-acivate {
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #999999;
      line-height: 2.2rem;
    }

    .child-text-acivate {
      color: #108b30;
    }

    .people-close-img {
      width: 1.0rem;
      height: 1.0rem;
      display: inline-block;
      margin-left: 0.5rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .form-info-div {}

  .people-form-div {
    padding-bottom: 1.5rem;
    background-color: #ffffff;
    padding-top: 2.1rem;

    .form-item-div {
      padding: 2.1rem 1.6rem 0 1.6rem;
      display: flex;

      div:first-child {
        flex: 1;
        height: 2.2rem;
        font-size: 1.6rem;
        font-weight: 400;
        color: #333333;
        line-height: 2.2rem;
      }

      div:last-child {
        width: 8.0rem;
      }

      &:first-child {
        padding-top: 0;
      }
    }
  }

  .child-info {
    padding: 2.0rem 1.5rem;
    position: relative;
    background-color: #ffffff;

    &::before {
      content: "";
      position: absolute;
      width: calc(100% - 3.0rem);
      top: 0;
      height: 0.1rem;
      background: #eeeeee;
    }

    .info-tip {
      height: 1.8rem;
      font-size: 1.3rem;
      font-weight: 400;
      color: #999999;
      line-height: 1.8rem;
    }

    .child-info-item {
      padding-top: 2.0rem;
      display: flex;

      .info-title {
        flex: 1;
        height: 2.2rem;
        font-size: 1.6rem;
        font-weight: 400;
        color: #333333;
        line-height: 2.2rem;
      }

      .info-yaer {
        // width: 42rem;
        height: 2.2rem;
        font-size: 1.6rem;
        font-weight: 500;
        color: #108b30;
        line-height: 2.2rem;
      }

      .child-img {
        display: inline-block;
        width: 1.2rem;
        height: 1.2rem;

        img {
          width: 100%;
          height: 100%;
          position: relative;
          left: -0.4rem;
          top: 0.1rem;
        }
      }
    }
  }

  .time-div {
    display: flex;
    background-color: #ffffff;

    .time-div-title {
      width: auto;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
    }

    .time-data {
      flex: 1;
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #108b30;
      line-height: 2.2rem;
      text-align: right;
    }

    .time-close-img {
      width: 1.0rem;
      height: 1.0rem;
      display: inline-block;
      position: relative;
      top: 0.5rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .checkin-pup-div {
    padding: 2.0rem;

    .pup-title {
      height: 2.2rem;
      font-size: 1.6rem;
      font-weight: 500;
      color: #333333;
      line-height: 2.2rem;
    }

    .pup-tip {
      height: 2.0rem;
      font-size: 1.4rem;
      font-weight: 400;
      color: #999999;
      line-height: 2.0rem;
      padding-top: 1.2rem;
    }

    .pup-child-btn,
    .pup-child-btn-activate {
      display: inline-block;
      width: 3.1rem;
      height: 2.0rem;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 2.0rem;
      padding: 0.8rem 1.4rem;
      color: #333333;
      background: #eeeeee;
      border-radius: 1.8rem;
      margin: 2.0rem 1.0rem 0 0;
      text-align: center;

      &:nth-child(5n + 2) {
        margin-right: 0;
      }
    }

    .pup-child-btn-activate {
      font-weight: 500;
      background: #108b30;
      color: #ffffff;
    }
  }

  .checkin-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #ffffff;
    box-shadow: 0 -0.5rem 1.0rem 0rem rgba(19, 19, 19, 0.1);
    padding: 1rem 1.5rem 1.5rem;
    z-index: 1;

    .checkin-btn,
    .checkin-btn-gray {
      width: calc(100% - 3.0rem);
      text-align: center;
      height: 2.5rem;
      font-size: 1.8rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 2.5rem;
      padding: 1.0rem 0;
      background: linear-gradient(135deg, #0fbf6d 0%, #108b30 100%);
      border-radius: 2.3rem;
    }

    .checkin-btn-gray {
      background: #999999
    }
  }
</style>